<template>
	<div id="katalog-tiket">
    <ol class="breadcrumb pull-right">
      <li><router-link :to="{path: '/'}">Home</router-link></li>
      <li>Content</li>
      <li class="active">Content Article</li>
    </ol>
    <!-- end breadcrumb -->
    <!-- begin page-header -->
    <h1 class="page-header">Artikel</h1>
    <!-- end page-header -->
		<div class="row">
      <div class="col-md-12">
        <!-- begin panel -->
        <div class="panel panel-inverse">
          <div class="panel-heading">
            <div class="pull-right">
              <button type="button" class="btn btn-success btn-xs m-r-5" @click="createContentArticle()"><span class="fa fa-plus"></span> Tambah Artikel</button>
							<!-- <button type="button" class="btn btn-success btn-xs dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
								Action <span class="caret"></span>
							</button>
							<ul class="dropdown-menu">
								<li><a @click="updateAllKatalogTiketStatus(status.PUBLISH)">Publish All</a></li>
								<li><a @click="updateAllKatalogTiketStatus(status.UNPUBLISH)">Unpublish All</a></li>
							</ul> -->
            </div>
            <h4 class="panel-title">List Content Article</h4>
          </div>
          <div class="panel-body">
						<app-datatable
							:items="KontenList"
							:has-action="true"
							:has-custom-pagination="true"
							:has-custom-search="true"
							:has-edit-a="true"
							:custom-pagination-current-page="pagination.currentPage"
							:custom-pagination-per-page="10"
							:custom-pagination-total-pages="pagination.totalPages"
							:custom-pagination-sort-mode="pagination.sortMode"
							:headers="headers"
							v-on:selected="selectedRow = $event"
							v-on:dblClicked="updateArticle()"
              				v-on:editNewTab="updateContentBtn($event)"
							v-on:deleted="deleteArticle($event)"
							v-on:changePage="pagination = {...pagination, currentPage: $event}"
							v-on:changeSortMode="pagination = {...pagination, sortMode: $event}"
							v-on:doSearch="search = {query: $event.value, by: headersKey[$event.key]}"
						/>
          </div>
        </div>
      </div>
		</div>
		<app-spinner v-if="isLoading"></app-spinner>
	</div>
</template>

<script>
import ContentService from '@/services/content.js'
import DataTable from '@/components/plugins/DataTable'
import Spinner from '@/components/plugins/Spinner'
import Moment from 'moment'

export default {
	name: 'katalog-tiket',
	components: {
		'app-datatable': DataTable,
		'app-spinner': Spinner,
	},
	data: function () {
		return {
			isLoading: false,
			KontenList: [],
      		fullData: [],
			status: {
				PUBLISH: 'PUBLISHED',
				UNPUBLISH: 'UNPUBLISHED'
			},
			selectedRow: null,
			search: null,
			pagination: {
				perPage: 25,
				currentPage: 1,
				totalPages: 0,
				sortMode: 'desc',
			},
			type: {
				// SCHEDULED_TRYOUT: 'SCHEDULED_TRYOUT',
				// INSTANT_TRYOUT: 'INSTANT_TRYOUT',
				// CONSULTATION: 'CONSULTATION',
				// DUEL: 'DUEL',
				// ITEM_BANK: 'ITEM_BANK',
				// VIDEO: 'VIDEO'
			},
			headers: ['Section Name', 'Judul', 'Link', 'Status'],
			headersKey: ['name', 'description', 'status'],
		}
	},
	mounted: function () {
		this.fetchData()
	},
	watch: {
		pagination: function () {
			this.fetchData()
		},
	},
	methods: {
		fetchData: function () {
			var context = this
			var search = this.search
			var pagination = {
				perPage: this.pagination.perPage,
				currentPage: this.pagination.currentPage,
				sortMode: this.pagination.sortMode,
				type: 'ARTICLE'
			}

			this.isLoading = true

			ContentService.getContentDetailList(pagination, search, function (result) {
				context.KontenList = []
				context.isLoading = false

				if (result.success) {
					if(pagination.currentPage > 1 && result.data.length < 1) {
						context.pagination.currentPage = parseInt(pagination.currentPage) - 1
						alert('Data hanya sampai halaman ' + context.pagination.currentPage)
						context.fetchData()
					} else if (pagination.currentPage === 1 && result.data.length === 0 ) {
						alert('Maaf, data belum ada ')
					}
					result.data.forEach(function (content) {
            		context.fullData.push(content)
					var conv = JSON.parse(content.content)
					var row = {
						id: content.id,
						data: [
						content.section.name,
						conv.title.length > 45 ? conv.title.substr(0,45) + ' ...' : conv.title,
						conv.link.length > 40 ? conv.link.substr(0,40) + ' ...' : conv.link,
						content.status,
						// Moment(content.created_at).format('YYYY-MM-DD') || '-',
						],
						status: content.status
					}
					context.pagination.totalPages = content.total_page
					context.KontenList.push(row)
					console.log(context.KontenList)
					})
				} else {
					alert('Terjadi Kesalahan : ' + result.data.message)
				}
			})
		},
		createContentArticle: function () {
			this.$router.push({ path: '/content/article-form' })
		},
		updateArticle: function () {
			var selected = this.fullData.find(element => {
				return element.id == this.selectedRow.id
			})
      		this.$store.commit('setEditDataContent', selected)
			this.$router.push({ path: '/content/article-form', query: { id: this.selectedRow.id}})
		},
		updateContentBtn: function (data) {
			console.log(this.fullData)
			var selected = this.fullData.find(element => {
				return element.id == data.id
			})
			this.$store.commit('setEditDataContent', selected)
					this.$router.push({ path: '/content/article-form', query: { id: data.id}
			})
		},
		deleteArticle: function (content) {
			var context = this
			var contentID = content.id
			var confirmed = window.confirm("Apakah anda yakin akan menghapus Artikel ini?")
			if (confirmed) {
				this.isLoading = true
				ContentService.deleteContentDetail(contentID, function (result) {
					context.isLoading = false
					if (result.success) {
						alert('Data Terhapus')
						context.fetchData()
					} else {
						alert('Terjadi Kesalahan : ' + result.message)
					}
				})
			}
		},
	}
}
</script>



// WEBPACK FOOTER //
// Article.vue?61bf010b